import { Component, Inject, Input, OnInit } from '@angular/core';
import { CaseModel } from '@app/ps/models/case.model';
import { CaseService } from '@app/ps/services/case.service';
import { StateService } from '@uirouter/angular';
import { CaseStatusService } from '@app/ps/services/case-status.service';
import { Restangular } from 'ngx-restangular';

@Component({
  selector: 'decline',
  templateUrl: './decline.component.html',
  styleUrls: ['./decline.component.scss']
})
export class DeclineComponent implements OnInit {

  @Input() caseId: number;
  loading = true;
  data: CaseModel;
  date = new Date();
  declineInvestorName: string;

  constructor(
    private restangular: Restangular,
    private caseStatusService: CaseStatusService,
    private caseService: CaseService,
    private stateService: StateService,
  ) {
    this.onDecline = this.onDecline.bind(this);
  }

  async ngOnInit() {
    this.data = await this.restangular.one('cases', this.caseId).get({ loadCollections: [ 'caseSubjects', 'titles' ]}).toPromise();
    this.declineInvestorName = (await this.caseStatusService.loadStatusName('DeclinedInvestor')).name;
    this.loading = false;
  }

  isValid() {
    return !!this.date;
  }

  async onDecline(): Promise<any> {
    await this.restangular
      .one('cases', this.caseId)
      .customPUT({ declinedInvestorDate: this.date }, 'decline-investor')
      .toPromise();
    this.stateService.go('^');
  }
}
